import { render, staticRenderFns } from "./oneAisle.vue?vue&type=template&id=040170a0&scoped=true"
import script from "./oneAisle.vue?vue&type=script&lang=js"
export * from "./oneAisle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040170a0",
  null
  
)

export default component.exports